module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "pg18lev1"
    }
  }), _c('img', {
    attrs: {
      "alt": "Cream of tomato soup with crunchy lemon chickpeas",
      "src": "images/f0018-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe_hdnote"
  }, [_vm._v("Anyone who has ever cooked and eaten on a budget in the United Kingdom will be familiar with some of Britain’s perennial foodstuffs: canned soup and tomatoey baked beans. They were the standby meals of choice back in my university days, and there is nothing quite like a cream of tomato soup to brighten up a winter night.")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_hdnote"
  }, [_vm._v("I love these lemony chickpeas (I always have a can of chickpeas on hand in the cupboard); they’re my version of croutons. I like to sprinkle them on top of soups, but they are equally delicious as a stand-in for nuts—a homemade bar snack.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0019-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Serves 4 as a starter")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Preparation time: 15 minutes")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Cooking time: 35 to 45 minutes")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("one 14-oz can chickpeas, drained and rinsed")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("1 unwaxed lemon, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("4 cloves of garlic, unpeeled")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("1 tbsp canola or other vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("sea salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("one 28-oz can good-quality cherry tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("1 cup vegetable stock or water")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("1 tsp sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("1 tbsp red wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("freshly ground pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('sup', [_vm._v("3")]), _vm._v("/"), _c('sub', [_vm._v("4")]), _vm._v(" cup heavy cream")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Preheat the oven to 350°F.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Combine the chickpeas, lemon slices, garlic, and oil in a small bowl and toss to coat. Place the chickpeas on a rimmed baking sheet. Sprinkle with salt and roast for 30 to 40 minutes, or until golden and crunchy.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Meanwhile, put the tomatoes and stock in a medium saucepan and bring to a simmer. Remove the roasted garlic from the baking sheet and squeeze the garlic from its papery husks, then add to the saucepan and simmer for 5 minutes. Add the sugar and vinegar and continue simmering for 1 minute. Taste for salt and pepper and stir in half the cream, then remove from the heat and use an immersion blender to blend until smooth.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Ladle the soup into bowls and garnish with the crunchy chickpeas, a slice of roasted lemon, and a drizzle of the remaining cream.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0018-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar2_hd"
  }, [_vm._v("Tip")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_c('em', [_vm._v("Don’t boil the soup with the cream in it, as it will curdle")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12845b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09-chapter03.vue
// module id = 81
// module chunks = 0